import { render, staticRenderFns } from "./SystemTypeCard.vue?vue&type=template&id=0410ff5a&scoped=true"
import script from "./SystemTypeCard.vue?vue&type=script&lang=js"
export * from "./SystemTypeCard.vue?vue&type=script&lang=js"
import style0 from "./SystemTypeCard.vue?vue&type=style&index=0&id=0410ff5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0410ff5a",
  null
  
)

export default component.exports